import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import NewFormWizard from '../../components/formWizard/NewFormWizard'
import NewFormWizardChild from '../../components/formWizard/NewFormWziardChild'
import Layout from '../../components/layouts/Layout'
import { LoadingSpinner } from '../../components/Loader/Loader'
import http, { URL_S3 } from '../../config/BaseUrl'
import UploadFile from '../../hook/UploadFile'
import brandingImage from '../../assets/images/custom-branding-image.jpeg'

function WaterMarkEdit() {

  const history = useHistory();
  const { id } = useParams()
  const dispatch = useDispatch()

  const customBranding = history.location.state.customBranding

  // custom hook
  const { fileURL, onChangeFile, setFileURL, fileName } = UploadFile()

  const [loading, setLoading] = useState(false)
  const [draftLoading, setDraftLoading] = useState(false)
  const [waterMark, setWaterMark] = useState('Watermark')
  const [waterMarkType, setWaterMarkType] = useState('text')
  const [xAxis, setXAxis] = useState('top')
  const [yAxis, setYAxis] = useState('left')
  const [tAxis, setTAxis] = useState('5px')
  const [lAxis, setlAxis] = useState('5px')
  const [photo, setPhoto] = useState('')
  const [brandingLogoWidth, setLogoWidth] = useState(30)

  useEffect(() => {
    if (customBranding) {
      setPhoto(`${URL_S3}image/watermark/${customBranding.photo}`)
      xCalculation(customBranding.align_x)
      yCalculation(customBranding.align_y)
    }
  }, [customBranding])

  const previewWaterMarkImage = {
    width: '380px',
    maxWidth: '100%',
    height: '100%',
    maxHeight: '488px',
    backgroundSize: 'contain',
    position: 'relative',
  }

  const previewWaterMarkStyle = {
    fontSize: '12px',
    color: '#fff',
    height: '30px',
    fontWeight: 'bold',
    position: 'absolute',
    transition: 'all .8s linear',
    marginBottom: '0',
    top: tAxis,
    left: lAxis,
  }

  const YAxisCalculate = (e) => {
    yCalculation(e.target.value)
  }
  const XAxisCalculate = (e) => {
    xCalculation(e.target.value)
  }



  const xCalculation = (value) => {
    if (value == "left") {
      setXAxis('left')
      setlAxis('20px')
    }
    else {
      setXAxis('right')
      setlAxis(`calc(100% - ${brandingLogoWidth + 20}px)`)
    }
  }

  const yCalculation = (value) => {
    if (value == "top") {
      setYAxis('top')
      setTAxis('20px')
    }
    else {
      setYAxis('bottom')
      setTAxis(`calc(100% - 50px)`)
    }
  }

  const setValueX = (value) => {
    xCalculation(value)
  }
  const setValueY = (value) => {
    yCalculation(value)
  }

  const saveWaterMark = (e) => {
    e.preventDefault();

    let waterMarkData = {
      photo: fileURL,
      align_x: xAxis,
      align_y: yAxis
    }

    setLoading(true)
    try {
      http.put(`watermark/${id}`, { ...waterMarkData, event_id: customBranding.event_id })
        .then(res => {
          setLoading(false)
          history.push(`/show/event/${customBranding.event_id}`, 'Information Updated.')
        })
    } catch (error) {
      setLoading(false)
    }
  }


  useEffect(() => {
    if (photo) {
      let img = document.getElementById("branding-logo")
      let src = img.src;

      let image = new Image();
      image.src = src

      image.onload = function () {
        setLogoWidth(img.width)
      }
    }
    if (fileURL) {
      let img = document.getElementById("branding-logo")
      let src = img.src;

      let image = new Image();
      image.src = src

      image.onload = function () {
        setLogoWidth(img.width)
      }
    }
  }, [fileURL, photo])


  return (
    <Layout>
      <NewFormWizard />
      <NewFormWizardChild />
      <section className="mt-5">
        <form >
          <div className="row justify-content-center">
            <div className="col-md-10">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="text-center col-12 col-ma-12">
                      <div className="pb-4">
                        <p className="mb-0 display-4 text-primary event-form-title">Custom Branding</p>
                        <p className="mb-0 text-secondary">Watermark your content and choose it's position</p>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="watermark-form h-100" style={{ display: 'grid', alignItems: 'center' }}>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Custom Branding Image</label>
                              <div className="mb-3 input-group">
                                <div className="custom-file">
                                  <input
                                    type="file"
                                    className="custom-file-input"
                                    id="inputGroupFile01"
                                    aria-describedby="inputGroupFileAddon01"
                                    onChange={e => { setWaterMarkType('image'); onChangeFile(e) }}
                                  />
                                  <label className="custom-file-label overflow-hidden" forHtml="inputGroupFile01">
                                    {fileName ? fileName.name : customBranding.photo}
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6 form-group">
                                <label>X Axis</label>
                                <div className={`switch-body ${xAxis}`}>
                                  <div className={`left-switch switch-item ${xAxis === "left" && 'active'}`} onClick={e => setValueX('left')}>
                                    <span>Left</span>
                                  </div>
                                  <div className={`right-switch switch-item ${xAxis === "right" && 'active'}`} onClick={e => setValueX('right')}>
                                    <span>Right</span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-6 form-group">
                                <label>Y Axis</label>
                                <div className={`switch-body ${yAxis}`}>
                                  <div className={`left-switch switch-item ${yAxis === "top" && 'active'}`} onClick={e => setValueY('top')}>
                                    <span>Top</span>
                                  </div>
                                  <div className={`right-switch switch-item ${yAxis === "bottom" && 'active'}`} onClick={e => setValueY('bottom')}>
                                    <span>Bottom</span>
                                  </div>
                                </div>
                              </div>
                            </div>


                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="preview-watermark">
                        <div className="image-preview" style={previewWaterMarkImage}>
                          <img src={`${URL_S3}static/custom_branding_preview.png`} className="img-fluid" alt="branding" style={{ height: 'auto', maxHeight: '100%' }} />
                          <div className="water-mark-image" style={previewWaterMarkStyle}>
                            <img src={fileURL || photo} className="img-fluid h-100" id="branding-logo" alt="custom-branding" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>



          <div className="my-5 row justify-content-center">
            <div className="col-md-10">
              {loading ?
                (<button className="float-right px-5 btn btn-primary radius-10" disabled>
                  <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                </button>)
                : <button type="submit" onClick={saveWaterMark} className="float-right px-5 btn btn-primary radius-10">Update</button>
              }
            </div>
          </div>
        </form>
      </section>
    </Layout>
  )
}

export default WaterMarkEdit
